import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { SafeAny } from '../../types/safe-any';

import { UserDetails } from './user.state.interface';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private readonly httpClient = inject(HttpClient);

  // TODO: modify types here based on API types.
  login(payload: SafeAny): Observable<SafeAny> {
    return this.httpClient.request<SafeAny>('post', `${environment.apiUrl}/login`, {
      body: payload,
      // withCredentials: true,
      headers: new HttpHeaders(),
    });
  }

  logout(): Observable<SafeAny> {
    return this.httpClient.post<SafeAny>(`${environment.apiUrl}/logout`, {});
  }

  getActiveUsers(payload: SafeAny): Observable<HttpResponse<UserDetails[]>> {
    return this.httpClient.get<UserDetails[]>(`${environment.apiUrl}/users`, {
      params: payload,
      observe: 'response',
    });
  }

  getArchivedUsers(payload: SafeAny): Observable<HttpResponse<UserDetails[]>> {
    return this.httpClient.get<UserDetails[]>(`${environment.apiUrl}/users`, {
      params: payload,
      observe: 'response',
    });
  }

  archiveUser(userId: string, status: string): Observable<UserDetails> {
    return this.httpClient.patch<UserDetails>(`${environment.apiUrl}/users/${userId}`, { status });
  }

  unarchiveUser(userId: string, status: string): Observable<UserDetails> {
    return this.httpClient.patch<UserDetails>(`${environment.apiUrl}/users/${userId}`, { status });
  }

  addUser(user: UserDetails): Observable<UserDetails> {
    return this.httpClient.post<UserDetails>(`${environment.apiUrl}/users`, user);
  }

  getUser(userId: string): Observable<UserDetails> {
    return this.httpClient.get<UserDetails>(`${environment.apiUrl}/users/${userId}`);
  }

  updateUser(payload: SafeAny, userId: string): Observable<UserDetails> {
    return this.httpClient.put<UserDetails>(`${environment.apiUrl}/users/${userId}`, payload);
  }

  getUserRoles(payload: SafeAny): Observable<SafeAny> {
    return this.httpClient.get<SafeAny>(`${environment.apiUrl}/drop-down-options`, {
      params: payload,
    });
  }

  resetPassword(userId: string): Observable<SafeAny> {
    return this.httpClient.patch<SafeAny>(`${environment.apiUrl}/users/${userId}`, {
      resetPassword: true,
    });
  }

  changePassword(payload: SafeAny, userId: string): Observable<SafeAny> {
    return this.httpClient.patch<SafeAny>(`${environment.apiUrl}/users/${userId}`, payload);
  }
}
